import script from "./HomeCatalog.vue?vue&type=script&setup=true&lang=ts"
export * from "./HomeCatalog.vue?vue&type=script&setup=true&lang=ts"

import "./HomeCatalog.vue?vue&type=style&index=0&id=53ca94b0&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53ca94b0"]])

export default __exports__